import MiDataTable from '@/components/MiDataTable/MiDataTable.vue';
import { Component } from 'vue-property-decorator';
import { getStatusColor, getStatusLabel, ReportStatusMap, reportStatusMap } from '@/support/ReportStatus';

import { Report } from '@/models/Report';
import { isEmpty } from 'lodash';

import { MiDataTableOptions, MiDataTableVisibility } from '@/components/MiDataTable/MiDataTable';
import { MiFormField } from '@/components/MiForm/MiForm';
import AbstractFilter from '@/views/AbstractFilter';
import ImportReportDialog from '@/views/Reports/ImportReportDialog/ImportReportDialog.vue';

@Component<Reports>({
  components: {
    ImportReportDialog,
  },
})
export default class Reports extends AbstractFilter {
  protected $pageTitle = 'Opdrachten';

  protected tableSearchInput = '';

  protected reports: Report[] = [];

  protected reportStatusMap: ReportStatusMap[] =[];

  protected isImportingReport = false;

  protected selectedFilter: Record<string, unknown> = {};

  protected isLoading = false;

  protected isShowingFilters = false;

  protected report: Report | null = null;

  protected filtersHeight = 0;

  protected tableFilters: Record<string, unknown> = {};

  protected defaultStatusFilters = ['hin_preparation', 'hin_waiting_for_signature', 'hin_assignment_accepted', 'hin_assignment_started', 'hin_assignment_completed', 'hin_evaluation_uploaded', 'hin_aborted'];

  protected contractorId = '';

  protected userTypeResolved = false;

  protected mounted(): void {
    this.resolveUserType();
  }

  protected resolveUserType(): void {
    if (this.$store.getters.isContractor) {
      this.contractorId = this.$store.getters.user.contractor.uuid;
    }

    this.userTypeResolved = true;
  }

  protected showFilters(): void {
    if (! this.isShowingFilters) {
      this.isShowingFilters = true;
      const innerFilters = document.getElementsByClassName('inner-filters');
      this.filtersHeight = innerFilters[0].clientHeight;
    } else {
      this.isShowingFilters = false;
      this.filtersHeight = 0;
    }
  }

  protected toggleImportDialog(): void {
    this.isImportingReport = ! this.isImportingReport;
  }

  protected getColor(key: string): string {
    return key;
  }

  protected getPillColor(status: string): string {
    return getStatusColor(status);
  }

  protected getPillLabel(status: string): string {
    return getStatusLabel(status);
  }

  protected appointmentIsScheduled(date: string): boolean {
    return !! date;
  }

  protected handleCloseImportDialog(): void {
    this.isImportingReport = false;
  }

  protected refreshTable(): void {
    (this.$refs.reportDatatable as MiDataTable).refresh();
  }

  protected get hasFilters(): boolean {
    let hasFilters = false;

    Object.keys(this.filters).forEach((tableFilterKey: string) => {
      if (tableFilterKey) {
        if ((this.filters as Record<string, unknown>)[tableFilterKey] === true) {
          hasFilters = true;
        } else if (! isEmpty((this.filters as Record<string, unknown>)[tableFilterKey]) && tableFilterKey !== 'status' && tableFilterKey !== 'planning_status') {
          hasFilters = true;
        }
      }
    });

    return hasFilters;
  }

  protected get filterFields(): MiFormField[] {
    return [
      {
        type: 'date_range',
        key: 'delivery_appointment',
        placeholder: 'Oplevermoment',
        hideDetails: true,
        clearable: true,
        collapsed: true,
        label: 'Oplevermoment',
        class: 'w-1/6 mr-16',
      },
      {
        type: 'select',
        items: reportStatusMap,
        itemText: 'label',
        itemValue: 'key',
        key: 'statuses',
        placeholder: 'Kies een status',
        hideDetails: true,
        clearable: true,
        multiple: true,
        collapsed: true,
        label: 'Status',
        class: 'w-1/6 mr-16',
      },
    ];
  }

  /**
   * Datatable config
   */

  protected get tableOptions(): MiDataTableOptions {
    return {
      model: new Report()
        .include(['contractor', 'has_witnessed'])
        .filter({ ...{ contractor: this.contractorId, statuses: this.defaultStatusFilters }, ...this.filters }),
      headers: [
        {
          text: 'Zaaknummer',
          value: 'case_number',
        },
        {
          text: 'IMG Zaaknummer',
          value: 'img_case_number',
          sortable: true,
        },
        {
          text: 'Startdatum',
          value: 'first_appointment',
          sortable: true,
        },
        {
          text: 'Oplevermoment',
          value: 'delivery_appointment',
          sortable: true,
        },
        {
          text: 'Adres',
          value: 'address',
          sortable: false,
        },
        {
          text: 'Schades',
          value: 'damage_count',
          sortable: true,
        },
        {
          text: 'Bedrag',
          value: 'assignment_value',
          sortable: true,
        },
        {
          text: 'Status',
          value: 'status_raw',
          sortable: true,
          align: 'end',
        },
      ],
    };
  }

  protected visibility(): MiDataTableVisibility {
    return {
      filters: true,
    };
  }
}
